import { useFormikContext } from 'formik';
import React, { useCallback, useState } from 'react';
import bt from '../bootstrap.module.css';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import useGetFormGeneratorItemError from '../hooks/useGetFormGeneratorItemError';

const TextInput = props => {
  const { isBuilder, disabled, readOnly } = props;
  const { id, placeholder, type, validation, label } = props.data;
  const { requiredError, error } = useGetFormGeneratorItemError(id, validation);
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = useCallback(
    e => {
      props.onChange(type, id, e.target.value);
    },
    [props],
  );

  const handleLabelChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className={bt['form-group']}>
        <div className="font-semibold">
          <InlineEdit
            value={label}
            onChange={handleLabelChange}
            fieldName="label"
            isEditing={isEditing}
            onSetIsEditing={setIsEditing}
            readOnly={readOnly}
          />
        </div>
        <input
          disabled={isBuilder || disabled}
          onChange={handleChange}
          className="block w-full border-b h-8 px-1"
          placeholder={placeholder}
          value={props.value || ''}
        />
        {(requiredError || error) && (
          <div style={{ color: 'red', marginTop: 4 }}>
            {requiredError ? 'This field is required' : error}
          </div>
        )}
      </div>
    </FormElementWrapper>
  );
};

export default TextInput;
